
import login from './pages/login'
import modules from './pages/modules'

const pageRouters = [
  login,
  modules
]

export default pageRouters
